<template>
  <div
    v-if="width > 700"
    class="bg-[#f4f4f4] flex rounded-lg px-2 py-1 border-2 border-b-gray-300"
  >
    <div class="max-w-fit my-auto">
      <iconSearch :size="20" :color="'#9ca3af'" />
    </div>

    <input
      id="searchBar"
      v-model="textInput"
      @keyup.enter="searchProducts"
      type="text"
      class="mx-2 focus:outline-none text-md bg-[#f4f4f4]"
      :class="isPortrait ? 'w-[11rem]' : 'w-[15rem]'"
      :placeholder="$t('Pos.SearchProducts')"
    />

    
    <div class="flex flex-row gap-2 max-w-fit my-auto items-center">
      <button
        v-if="textInput.length"
        type="button"
        class="p-0.5 rounded hover:bg-gray-200 focus:outline-none flex items-center justify-center"
        :aria-label="$t('Pos.Clear')"
        @click="resetFilter"
      >
        <img
          src="@/assets/icons/close_icon.svg"
          alt="Clear"
          class="w-5 h-5 opacity-70 hover:opacity-100"
        />
      </button>
      <iconKeyboard v-if="posConfig.posConfig.showKeyboard == 1" :size="20" :color="'#000'" @click="selectInput" />
    </div>
  </div>
  <LbrxKeyboardPopup
    :active="modalKeyboard.active"
    :initial-text="textInput"
    @closePopupKeyboard="closePopupKeyboard"
  />
</template>

<script>
import LbrxKeyboardPopup from "@/components/LbrxKeyboardPopup.vue";
import iconSearch from "./icons/iconSearch.vue";
import iconKeyboard from "./icons/iconKeyboard.vue";
export default {
  name: "LbrxSearchBar",
  components: {
    iconSearch,
    LbrxKeyboardPopup,
    iconKeyboard
  },
  data() {
    return {
      textInput: "",
      modalKeyboard: {
        active: false,
      },
      width: window.screen.width,
      showClose: false,
    };
  },
  props: {
    posConfig: {
      required: true,
      value: Object,
    },
    isPortrait: {
      required: true,
      value: Boolean,
    },
  },
  methods: {
    searchProducts(event) {
      const inputValue = event.target.value;
      this.textInput = inputValue;
      window.dispatchEvent(
        new CustomEvent("cart-search", {
          detail: {
            search: inputValue,
          },
        })
      );
     
      
    },
    selectInput() {
      if (this.posConfig.posConfig.showKeyboard == 1) {
        this.modalKeyboard.active = true;
      }
    },
    closePopupKeyboard(text) {
      this.textInput = text;
      const inputEl = document.getElementById("searchBar");
      if (inputEl) inputEl.value = text;
      window.dispatchEvent(
        new CustomEvent("cart-search", {
          detail: {
            search: text,
          },
        })
      );
      this.modalKeyboard.active = false;
      this.showClose = true;
    },
    resetFilter() {
      this.textInput = "";
      const inputEl = document.getElementById("searchBar");
      if (inputEl) inputEl.value = "";
      this.showClose = false;
      window.dispatchEvent(new CustomEvent("reset-cart-search"));
    }
  },
};
</script>

<style scoped></style>